import { media } from '@atlaskit/primitives/responsive';
import { token } from '@atlaskit/tokens';
import { BodyNormal, FluidContainer, H3, H5 } from '@atlassian/mpac-primitives';
import { styled } from '@compiled/react';

export const CardContainer = styled(FluidContainer)({
  [media.above.md]: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: token('space.400'),
  },
});

export const Card = styled.div({
  [media.above.md]: {
    gridColumn: '2 / 12',
    margin: `0 ${token('space.negative.400')}`,
  },

  display: 'flex',
  flexDirection: 'column',
  gap: token('space.500'),
  backgroundColor: token('elevation.surface'),
  padding: token('space.400'),
  borderRadius: '12px',

  [media.below.md]: {
    padding: `${token('space.400')} ${token('space.300')}`,
    gap: token('space.200'),
  },

  [media.below.sm]: {
    padding: `${token('space.300')} ${token('space.400')}`,
    gap: token('space.400'),
  },
});

export const Heading = styled(H3)({
  [media.above.md]: {
    textAlign: 'center',
  },
});

export const UseCases = styled.div({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',

  [media.below.md]: {
    gridTemplateColumns: '1fr',
    rowGap: token('space.200'),
  },

  [media.below.sm]: {
    rowGap: token('space.400'),
  },
});

export const UseCase = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: token('space.100'),
  padding: `${token('space.075')} 0`,
  alignItems: 'center',
  textAlign: 'center',

  [media.above.md]: {
    '&:first-of-type': {
      paddingRight: token('space.400'),
    },
    '&:nth-of-type(2)': {
      paddingLeft: token('space.400'),
      paddingRight: token('space.400'),
      borderLeft: `1px solid ${token('color.border.bold')}`,
    },
    '&:nth-of-type(3)': {
      paddingLeft: token('space.400'),
      borderLeft: `1px solid ${token('color.border.bold')}`,
    },
  },

  [media.below.md]: {
    padding: 0,
  },
});

export const Title = styled(H5)({
  marginBottom: 0,
});

export const Description = styled(BodyNormal)({
  marginTop: 0,
});
